import { createI18n } from 'vue-i18n'

const savedLocale = 'en'

const messages = {
  zh: {
    loading: {
      downloading_resources: '正在下载资源',
      loading_resources: '正在加载资源',
      tip_quiet_env: '为了避免收音干扰，请尽量在安静环境中'
    },
    disclaimers: {
      lesson_ai: '声明：本课图片、人物形象和配音均由AI生成。'
    },
    authorization: {
      tip_title: '温馨提示',
      tip_body: '请在安静的环境中进行学习，并保证麦克风和视频功能可用。',
      tip_landscape: '为保证最佳学习效果，请横屏播放。'
    },
    common: {
      start_learning: '开始学习',
      save: '保存',
      cancel: '取消'
    },
    teacher: {
      qa: {
        title: '老师提问',
        input_hint: '请输入语音或文字进行问答，回答完毕点击右下角箭头提交。',
        recording: '录音中'
      }
    },
    course: {
      disclaimer: '声明：本课图片、人物形象和配音均由AI生成。',
      outline: { title: '课堂目录' }
    },
    settings: {
      title: '学习设置',
      auto_record_teacher_qa: '教师提问环节自动开启录音',
      enable_camera: '为了保证上课效果，请打开摄像头'
    },
    camera: { off_label: '摄像头已关' },
    student: {
      qa: { title: '学生提问', input_hint: '请发送文字或语音进行提问' }
    },
    system: { network_error: '网络故障，请检查您的网络' }
  },
  en: {
    loading: {
      downloading_resources: 'Downloading Resources',
      loading_resources: 'Loading Resources',
      tip_quiet_env: 'To avoid microphone interference, please try to be in a quiet environment.'
    },
    disclaimers: { lesson_ai: 'Disclaimer: All images, characters, and voice-overs in this lesson were generated by AI.' },
    authorization: { tip_title: 'Friendly Reminder', tip_body: 'Please study in a quiet environment and ensure that your microphone and video functions are working.', tip_landscape: 'For the best learning experience, please play in landscape mode.' },
    common: { start_learning: 'Start Learning', save: 'Save', cancel: 'Cancel' },
    teacher: { qa: { title: 'Teacher Q&A', input_hint: 'Please enter your response by voice or text; click the arrow in the lower-right corner to submit once finished.', recording: 'Recording…' } },
    course: { disclaimer: 'Disclaimer: All images, characters, and voice-overs in this lesson were generated by AI.', outline: { title: 'Course Outline' } },
    settings: { title: 'Learning Settings', auto_record_teacher_qa: 'Auto-recording activated for teacher Q&A segment.', enable_camera: 'To ensure instructional efficacy, please enable your camera.' },
    camera: { off_label: 'Camera: Off' },
    student: { qa: { title: 'Student Q&A', input_hint: 'Please submit your question by text or voice.' } },
    system: { network_error: 'Network error—please check your connection.' }
  },
  ar: {
    loading: {
      downloading_resources: 'جاري تنزيل الموارد',
      loading_resources: 'جاري تحميل الموارد',
      tip_quiet_env: 'لتجنب تشويش الميكروفون، يُرجى التواجد في بيئة هادئة قدر الإمكان.'
    },
    disclaimers: { lesson_ai: 'تنويه: جميع الصور والشخصيات والأصوات الصوتية في هذا الدرس تم إنشاؤها بواسطة الذكاء الاصطناعي.' },
    authorization: { tip_title: 'تذكير ودّي', tip_body: 'يُرجى الدراسة في بيئة هادئة، والتأكد من أن وظائف الميكروفون والفيديو تعمل بشكل صحيح.', tip_landscape: 'للحصول على أفضل تجربة تعليمية، يرجى اللعب في الوضع الأفقي.' },
    common: { start_learning: 'بدء الدراسة', save: 'احفظ', cancel: 'إلغاء' },
    teacher: { qa: { title: 'أسئلة المعلّم (Q&A)', input_hint: 'يرجى إدخال ردك عبر الصوت أو النص، ثم اضغط على السهم في الأسفل الأيمن للإرسال فور الانتهاء.', recording: 'تسجيل صوتي جارٍ' } },
    course: { disclaimer: 'تنويه: جميع الصور والشخصيات والأصوات الصوتية في هذا الدرس تم إنشاؤها بواسطة الذكاء الاصطناعي.', outline: { title: 'الدراسي مُلَخَّص' } },
    settings: { title: 'إعدادات التعلّم', auto_record_teacher_qa: 'تم تفعيل التسجيل التلقائي لجلسة أسئلة المعلّم.', enable_camera: 'لضمان الفعالية التعليمية، يرجى تفعيل الكاميرا.' },
    camera: { off_label: 'الكاميرا: مغلقة' },
    student: { qa: { title: 'أسئلة الطلاب (Q&A)', input_hint: 'يرجى إرسال سؤالك عبر النص أو الصوت.' } },
    system: { network_error: 'خطأ في الشبكة؛ تحقّق من اتصالك.' }
  },
  es: {
    loading: { downloading_resources: 'Descargando Recursos', loading_resources: 'Cargando Recursos', tip_quiet_env: 'Para evitar interferencias en el micrófono, por favor, procura estar en un entorno tranquilo.' },
    disclaimers: { lesson_ai: 'Descargo de responsabilidad: Todas las imágenes, personajes y voces en off de esta lección fueron generados por IA.' },
    authorization: { tip_title: 'Recordatorio Amable', tip_body: 'Por favor, estudia en un entorno tranquilo y asegúrate de que el micrófono y la cámara funcionen correctamente.', tip_landscape: 'Para obtener la mejor experiencia de aprendizaje, reproduzca en modo horizontal.' },
    common: { start_learning: 'Comenzar a Estudiar', save: 'Guardar', cancel: 'Cancelar' },
    teacher: { qa: { title: 'Pregunta del docente', input_hint: 'Introduzca su respuesta por voz o texto; haga clic en la flecha inferior derecha para enviar cuando termine.', recording: 'Grabando audio…' } },
    course: { disclaimer: 'Descargo de responsabilidad: Todas las imágenes, personajes y voces en off de esta lección fueron generados por IA.', outline: { title: 'Esquema del curso' } },
    settings: { title: 'Configuración de aprendizaje', auto_record_teacher_qa: 'Grabando audio automática activada para el segmento de preguntas al docente.', enable_camera: 'Para garantizar la eficacia instruccional, active su cámara.' },
    camera: { off_label: 'Cámara: desactivada' },
    student: { qa: { title: 'Preguntas del estudiante (Q&A)', input_hint: 'Envíe su pregunta por texto o voz.' } },
    system: { network_error: 'Error de red; verifique su conexión.' }
  },
  it: {
    loading: { downloading_resources: 'Download Risorse in Corso', loading_resources: 'Caricamento Risorse in Corso', tip_quiet_env: 'Per evitare interferenze del microfono, si prega di trovarsi in un ambiente silenzioso.' },
    disclaimers: { lesson_ai: 'Nota legale: Tutte le immagini, i personaggi e i doppiaggi di questa lezione sono stati generati da intelligenza artificiale.' },
    authorization: { tip_title: 'Gentile Promemoria', tip_body: 'Si prega di studiare in un ambiente tranquillo e di assicurarsi che microfono e videocamera siano funzionanti.', tip_landscape: 'Per la migliore esperienza di apprendimento, riproduci in modalità orizzontale.' },
    common: { start_learning: 'Inizia a Studiare', save: 'Salva', cancel: 'Annulla' },
    teacher: { qa: { title: 'Q&A Docente', input_hint: 'Inserisci la risposta tramite voce o testo; clicca la freccia in basso a destra per inviare.', recording: 'Registrazione audio in corso' } },
    course: { disclaimer: 'Nota legale: Tutte le immagini, i personaggi e i doppiaggi di questa lezione sono stati generati da intelligenza artificiale.', outline: { title: 'Programma del corso' } },
    settings: { title: 'Impostazioni di apprendimento', auto_record_teacher_qa: 'Registrazione audio in corso automatica attivata per la sezione Q&A docente.', enable_camera: 'Per garantire l’efficacia didattica, attiva la webcam.' },
    camera: { off_label: 'Webcam: spenta' },
    student: { qa: { title: 'Q&A Studente', input_hint: 'Invia la tua domanda per testo o voce.' } },
    system: { network_error: 'Errore di rete: verificare la connessione di rete.' }
  },
  ru: {
    loading: { downloading_resources: 'Идёт загрузка ресурсов', loading_resources: 'Идёт загрузка ресурсов', tip_quiet_env: 'Во избежание помех для микрофона, пожалуйста, постарайтесь находиться в тихом месте.' },
    disclaimers: { lesson_ai: 'Отказ от ответственности: все изображения, персонажи и закадровый голос в данном уроке были созданы ИИ.' },
    authorization: { tip_title: 'Дружеское напоминание', tip_body: 'Пожалуйста, занимайтесь в тихой обстановке и убедитесь, что микрофон и камера работают.', tip_landscape: 'Для наилучшего обучения, пожалуйста, используйте горизонтальный режим.' },
    common: { start_learning: 'Начать обучение', save: 'Сохранить', cancel: 'Отмена' },
    teacher: { qa: { title: 'Q&A преподавателя', input_hint: 'Введите ответ голосом или текстом; нажмите стрелку в правом нижнем углу для отправки.', recording: 'Идёт запись' } },
    course: { disclaimer: 'Отказ от ответственности: все изображения, персонажи и закадровый голос в данном уроке были созданы ИИ.', outline: { title: 'Структура курса' } },
    settings: { title: 'Настройки обучения', auto_record_teacher_qa: 'Автозапись активирована для сегмента Q&A преподавателя.', enable_camera: 'Для обеспечения instructional-efficacy включите камеру.' },
    camera: { off_label: 'Камера: выкл' },
    student: { qa: { title: 'Вопрос студента', input_hint: 'Отправьте вопрос текстом или голосом.' } },
    system: { network_error: 'Ошибка сети — проверьте подключение.' }
  },
  fr: {
    loading: { downloading_resources: 'Téléchargement des Ressources', loading_resources: 'Chargement des Ressources', tip_quiet_env: 'Pour éviter les interférences du microphone, veuillez essayer de vous trouver dans un environnement calme.' },
    disclaimers: { lesson_ai: 'Avertissement : Toutes les images, les personnages et les voix off de cette leçon ont été générés par l’IA.' },
    authorization: { tip_title: 'Rappel Aimable', tip_body: 'Veuillez étudier dans un environnement calme et vous assurer que votre microphone et votre caméra fonctionnent.', tip_landscape: 'Pour une meilleure expérience d\'apprentissage, veuillez jouer en mode paysage.' },
    common: { start_learning: 'Commencer l\'Apprentissage', save: 'Enregistrer', cancel: 'Annuler' },
    teacher: { qa: { title: 'Q&A Enseignant', input_hint: 'Veuillez saisir votre réponse par voix ou texte, puis cliquez sur la flèche en bas à droite pour envoyer.', recording: 'Enregistrement audio en cours…' } },
    course: { disclaimer: 'Avertissement : Toutes les images, les personnages et les voix off de cette leçon ont été générés par l’IA.', outline: { title: 'Plan du cours' } },
    settings: { title: 'Paramètres d’apprentissage', auto_record_teacher_qa: 'Enregistrement audio en cours automatique activé pour la section Q&A enseignant.', enable_camera: 'Pour garantir l’efficacité pédagogique, veuillez activer votre caméra.' },
    camera: { off_label: 'Caméra : désactivée' },
    student: { qa: { title: 'Q&A Étudiant', input_hint: 'Veuillez soumettre votre question par texte ou voix.' } },
    system: { network_error: 'Erreur réseau – vérifiez votre connexion.' }
  },
  ja: {
    loading: { downloading_resources: 'リソースをダウンロード中', loading_resources: 'リソースを読み込み中', tip_quiet_env: 'マイクの干渉を避けるため、できるだけ静かな環境で行ってください。' },
    disclaimers: { lesson_ai: '注記：本講義の画像・キャラクター・ボイスはすべてAI生成です。' },
    authorization: { tip_title: 'ご案内', tip_body: '静かな環境で学習を行い、マイクとビデオ機能が利用可能であることを確認してください。', tip_landscape: '最適な学習効果を得るために、横画面で再生してください。' },
    common: { start_learning: '学習を開始', save: '保存', cancel: 'キャンセル' },
    teacher: { qa: { title: '教師質問', input_hint: '音声またはテキストで回答を入力し、終了後は右下の矢印をクリックして送信してください。', recording: '録音中' } },
    course: { disclaimer: '注記：本講義の画像・キャラクター・ボイスはすべてAI生成です。', outline: { title: '授業目次' } },
    settings: { title: '学習設定', auto_record_teacher_qa: '教師質問セグメントに自動録音が有効です。', enable_camera: '授業品質を確保するため、カメラをオンにしてください。' },
    camera: { off_label: 'カメラ：オフ' },
    student: { qa: { title: '学生質問', input_hint: '質問をテキストまたは音声で送信してください。' } },
    system: { network_error: 'ネットワークエラー：接続を確認してください。' }
  },
  ko: {
    loading: { downloading_resources: '리소스 다운로드 중', loading_resources: '리소스 로딩 중', tip_quiet_env: '마이크 간섭을 방지하기 위해 가능한 한 조용한 환경에서 진행해 주세요.' },
    disclaimers: { lesson_ai: '안내: 본 수업의 이미지, 캐릭터 및 음성은 모두 AI 생성입니다.' },
    authorization: { tip_title: '안내 말씀', tip_body: '조용한 환경에서 학습을 진행하고, 마이크와 영상 기능이 사용 가능한지 확인해 주세요.', tip_landscape: '최상의 학습 효과를 위해 가로 모드로 재생해 주세요.' },
    common: { start_learning: '학습 시작', save: '저장', cancel: '취소' },
    teacher: { qa: { title: '교사 질의', input_hint: '음성 또는 텍스트로 답변을 입력하세요. 완료 후 우측 하단 화살표를 클릭하여 제출합니다.', recording: '녹음 중' } },
    course: { disclaimer: '안내: 본 수업의 이미지, 캐릭터 및 음성은 모두 AI 생성입니다.', outline: { title: '수업 목차' } },
    settings: { title: '학습 설정', auto_record_teacher_qa: '교사 질의环节 자동 녹음이 활성화되었습니다.', enable_camera: '수업 효율을 위해 카메라를 켜 주세요.' },
    camera: { off_label: '카메라: 꺼짐' },
    student: { qa: { title: '학생 질의', input_hint: '질문을 텍스트나 음성으로 보내 주세요.' } },
    system: { network_error: '네트워크 오류: 연결 상태를 확인하세요.' }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages
})

export default i18n